var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.access)?_c('ContractorsAddresses'):_c('NoAccess')}
var staticRenderFns = []

export { render, staticRenderFns }